import moment, { Moment } from 'moment';

import { isEqual } from 'lodash';

function getDiffF<T extends { [key: string]: any }>(original: T, current: T) {
  const update: { [key: string]: any } = {};

  Object.keys(current).forEach((key) => {
    if (original[key] instanceof moment && current[key] instanceof moment) {
      if ((original[key] as Moment).unix() !== (current[key] as Moment).unix())
        update[key] = current[key];
    } else if (!isEqual(original[key], current[key])) {
      update[key] = current[key];
    }
  });

  return update as T;
}

export const getDiff = getDiffF;
